/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { flattenDependencies } from './dependenciesFlatten.generated.js';
import { matrixDependencies } from './dependenciesMatrix.generated.js';
import { sizeDependencies } from './dependenciesSize.generated.js';
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createMatrixFromRows } from '../../factoriesAny.js';
export var matrixFromRowsDependencies = {
  flattenDependencies,
  matrixDependencies,
  sizeDependencies,
  typedDependencies,
  createMatrixFromRows
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/esm/entry/dependenciesAny/dependenciesMatrixFromRows.generated.js
// module id = 97HT
// module chunks = 3